import React, {useEffect } from "react";
import ClaimSelect from './Claims/ClaimSelect'
import StepperUnemployment from './Claims/StepperUnemployment'
import StepperWorkIncapacity from './Claims/StepperWorkIncapacity'
import StepperHospitalised from './Claims/StepperHospitalised'
import ApplicationConfirmation from './Claims/ApplicationConfirmation'
import { useAppState } from "../application/AppState";

const Claims = () => {
    const [{ selectedClaim }] = useAppState();

    useEffect(() => {

    }, []);

    const renderApplicationResult = () => {        
        if (selectedClaim) {
            if (selectedClaim == 1) {
                return <StepperUnemployment />;
            } else if (selectedClaim == 2) {
                return <StepperWorkIncapacity />
            } else if (selectedClaim == 3) {
                return <StepperHospitalised />
            } else if (selectedClaim == 4) {
                return <ApplicationConfirmation />
            }
            else {
                return <ClaimSelect />;
            }
        } else {
            return <ClaimSelect />;
        }
    };

    return (      
        <div>{renderApplicationResult()}</div>
    );
}

export default Claims;